/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestUpdateBaseRequest
 */
export interface RequestUpdateBaseRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateBaseRequest
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateBaseRequest
     */
    baseName?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateBaseRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateBaseRequest
     */
    mailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateBaseRequest
     */
    phoneNum?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateBaseRequest
     */
    postNum?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateBaseRequest
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateBaseRequest
     */
    updatedUserId?: number;
}

/**
 * Check if a given object implements the RequestUpdateBaseRequest interface.
 */
export function instanceOfRequestUpdateBaseRequest(value: object): value is RequestUpdateBaseRequest {
    return true;
}

export function RequestUpdateBaseRequestFromJSON(json: any): RequestUpdateBaseRequest {
    return RequestUpdateBaseRequestFromJSONTyped(json, false);
}

export function RequestUpdateBaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestUpdateBaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'address': json['address'] == null ? undefined : json['address'],
        'baseName': json['base_name'] == null ? undefined : json['base_name'],
        'id': json['id'] == null ? undefined : json['id'],
        'mailAddress': json['mail_address'] == null ? undefined : json['mail_address'],
        'phoneNum': json['phone_num'] == null ? undefined : json['phone_num'],
        'postNum': json['post_num'] == null ? undefined : json['post_num'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'updatedUserId': json['updated_user_id'] == null ? undefined : json['updated_user_id'],
    };
}

export function RequestUpdateBaseRequestToJSON(json: any): RequestUpdateBaseRequest {
    return RequestUpdateBaseRequestToJSONTyped(json, false);
}

export function RequestUpdateBaseRequestToJSONTyped(value?: RequestUpdateBaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': value['address'],
        'base_name': value['baseName'],
        'id': value['id'],
        'mail_address': value['mailAddress'],
        'phone_num': value['phoneNum'],
        'post_num': value['postNum'],
        'tenant_id': value['tenantId'],
        'updated_user_id': value['updatedUserId'],
    };
}

